import React from 'react';
import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Container from 'react-bootstrap/Container';
// import Button from 'react-bootstrap/Button';

export const chartBlue = '#7eb1dc';
export const chartRed = '#f93944';
export const evenRowColor = '#EFEFFF';

export const titleBarStyle = {
    backgroundColor: '#4267B2',
    color: 'white',
    padding:'5px',
    textAlign: 'center'        
};

export const warningBarStyle = {
    backgroundColor: '#f0ad4e',
    color: 'white',
    textAlign: 'center'        
};

export const wizzardBarStyle = {
    backgroundColor: '#4267B2',
    color: 'white',
    padding:'2px',
    textAlign: 'center',
    fontWeight: 'normal'        
};

export const barStyle = {
    backgroundColor: '#4267B2',
    color: 'white',
    paddingTop:'7px'        
};

export const longButtonStyle = {
    display: 'block',
    width: '100%',
    marginBottom: '10px'
  };

//fa fa-bar-home - summary
//fa fa-bar-chart - reports
//fa fa-bar-tasks - account
//fa fa-bar-book or list - assignments
//fa fa-bar-male - class/student
//fa fa-bar-dollar or table or undo - subscribe
//fa fa-bar-database - database

export function IconSummary({children, ...props}) {return <i {...props} className="fa fa-home">{children}</i>;}
export function IconReports({children, ...props}) {return <i {...props} className="fa fa-bar-chart">{children}</i>;}
export function IconAssignments({children, ...props}) {return <i {...props} className="fa fa-list">{children}</i>;}
export function IconClasses({children, ...props}) {return <i {...props} className="fa fa-male">{children}</i>;}
export function IconSubscriptions({children, ...props}) {return <i {...props} className="fa fa-undo">{children}</i>;}
export function IconDatabase({children, ...props}) {return <i {...props} className="fa fa-database">{children}</i>;}
export function IconAccount({children, ...props}) {return <i {...props} className="IconSelected-tasks">{children}</i>;}

export function IconDownload({children, ...props}) {return <i {...props} className="fa fa-download">{children}</i>;}
export function IconEdit({children, ...props}) {return <i {...props} className="fa fa-pencil-square-o">{children}</i>;}

export function IconEye({children, ...props}) {return <i {...props} className="fa fa-bar-eye">{children}</i>;}
export function IconHouse({children, ...props}) {return <i {...props} className="fa fa-bar-chart">{children}</i>;}
export function IconCheck({children, ...props}) { return <i {...props} className="fa fa-check">{children}</i>;}
export function IconLock({children, ...props}) { return <i {...props} className="fa fa-lock">{children}</i>;}
export function IconStar({children, ...props}) { return <i {...props} className="fa fa-star">{children}</i>;}
export function IconCircle({children, ...props}) { return <i {...props} className="fa fa-circle">{children}</i>;}
export function IconClose({children, ...props}) { return <i {...props} className="fa fa-close">{children}</i>;}
export function IconHelp({children, tooltip = '', ...props}) { return <i {...props} data-toggle={tooltip} title={tooltip} className="fa fa-question-circle">{children}</i>;}
export function IconExpandCollapse({children, isOpen, ...props}) {
    return <>
        {isOpen && <i {...props} className="fa fa-caret-down">{children}</i>}
        {!isOpen && <i {...props} className="fa fa-caret-right">{children}</i>}
    </>;
}
export function IconSelected({children, isSelected, ...props}) {
    return <>
        {/* {isSelected && <i {...props} className="fa fa-check-square">{children}</i>}
        {!isSelected && <i {...props} className="far fa-square">{children}</i>} */}
    </>;
}
export function ClassIconSelected({children, isSelected, ...props}) {
    return <>
        {isSelected && <i {...props} className="fa fa-check-square">{children}</i>}
        {!isSelected && <i {...props} className="fa fa-plus">{children}</i>}
    </>;
}
export function EyeIconSelected({children, isSelected, ...props}) {
    return <>
        {isSelected && <i {...props} className="fa fa-check-square">{children}</i>}
        {!isSelected && <i {...props} className="fa fa-eye">{children}</i>}
    </>;
}
export function TitleBar({children}) {return <Row style={titleBarStyle}>{children}</Row>;};
export function WarningTitleBar({children}) {return <Row style={warningBarStyle}>{children}</Row>;};

